import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fath-payment-history--------------------------
export const getPaymentApi = async (data) => {
  const endPoint =
    `/fund/billing_list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
